import React, { useEffect } from "react";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router";

const Login = () => {
  const [viewState, setViewState] = React.useState({
    email: "",
    code: "",
    codeRequested: false,
  });
  const [uiState, setUiState] = React.useState({
    loading: false,
    error: "",
    success: "",
  });

  const { login, authenticate, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated]);
  // use flowbite css framework for styling
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100">
      <div className="container mx-auto flex min-h-screen items-center justify-center px-4">
        <div className="w-full max-w-md">
          <div className="rounded-2xl border border-slate-200 bg-white/90 p-8 shadow-xl backdrop-blur">
            <div className="mb-6 text-center">
              <h1 className="text-3xl font-semibold text-slate-900">Login</h1>
              <p className="mt-2 text-sm text-slate-500">
                Accede con tu correo y el código de acceso
              </p>
            </div>

            {uiState.error && (
              <div className="mb-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                {uiState.error}
              </div>
            )}
            {uiState.success && (
              <div className="mb-4 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-700">
                {uiState.success}
              </div>
            )}

            <form className="mt-2 space-y-6">
              {!viewState.codeRequested ? (
                <div className="space-y-4 transition-all duration-300">
                  <div>
                    <label className="block text-sm font-medium text-slate-700">
                      Email
                    </label>
                    <input
                      type="email"
                      className="mt-2 w-full rounded-xl border border-slate-300 px-4 py-3 text-slate-900 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                      placeholder="nombre@correo.com"
                      value={viewState.email}
                      onChange={(e) => {
                        setViewState({ ...viewState, email: e.target.value });
                        setUiState({ ...uiState, error: "", success: "" });
                      }}
                    />
                  </div>
                  <button
                    onClick={async (e) => {
                      e.preventDefault();
                      if (!viewState.email) {
                        setUiState({
                          ...uiState,
                          error: "Ingresa un email válido.",
                          success: "",
                        });
                        return;
                      }
                      try {
                        setUiState({
                          ...uiState,
                          loading: true,
                          error: "",
                          success: "",
                        });
                        await login(viewState.email);
                        setViewState({ ...viewState, codeRequested: true });
                        setUiState({
                          ...uiState,
                          loading: false,
                          success:
                            "Te enviamos un código. Revísalo y continúa.",
                        });
                      } catch (err) {
                        setUiState({
                          ...uiState,
                          loading: false,
                          error:
                            "No se pudo enviar el código. Intenta de nuevo.",
                        });
                      }
                    }}
                    className="w-full rounded-xl bg-blue-600 py-3 text-white shadow-lg transition hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-300 disabled:cursor-not-allowed disabled:opacity-60"
                    disabled={uiState.loading}
                  >
                    {uiState.loading ? "Enviando..." : "Solicitar código"}
                  </button>
                </div>
              ) : (
                <div className="space-y-4 transition-all duration-300">
                  <div className="flex items-center justify-between">
                    <div className="text-sm text-slate-600">
                      Enviado a{" "}
                      <span className="font-medium text-slate-900">
                        {viewState.email}
                      </span>
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        setViewState({
                          ...viewState,
                          codeRequested: false,
                          code: "",
                        });
                        setUiState({ ...uiState, error: "", success: "" });
                      }}
                      className="text-sm font-medium text-blue-600 hover:text-blue-500"
                    >
                      Editar email
                    </button>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700">
                      Código de acceso
                    </label>
                    <input
                      type="text"
                      className="mt-2 w-full rounded-xl border border-slate-300 px-4 py-3 text-slate-900 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                      placeholder="Ingresa tu código"
                      value={viewState.code}
                      onChange={(e) => {
                        setViewState({ ...viewState, code: e.target.value });
                        setUiState({ ...uiState, error: "", success: "" });
                      }}
                    />
                  </div>
                  <button
                    onClick={async (e) => {
                      e.preventDefault();
                      if (!viewState.code) {
                        setUiState({
                          ...uiState,
                          error: "Ingresa el código que recibiste.",
                          success: "",
                        });
                        return;
                      }
                      try {
                        setUiState({
                          ...uiState,
                          loading: true,
                          error: "",
                          success: "",
                        });
                        var resAuth = await authenticate(
                          viewState.email,
                          parseInt(viewState.code),
                        );
                        if (resAuth?.error) {
                          setUiState({
                            ...uiState,
                            loading: false,
                            error: resAuth.error,
                          });
                          return;
                        }
                        setUiState({
                          ...uiState,
                          loading: false,
                          success: "Acceso concedido. Redirigiendo...",
                        });
                        navigate("/");
                      } catch (err) {
                        setUiState({
                          ...uiState,
                          loading: false,
                          error:
                            "No pudimos validar el código. Inténtalo otra vez.",
                        });
                      }
                    }}
                    className="w-full rounded-xl bg-blue-600 py-3 text-white shadow-lg transition hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-300 disabled:cursor-not-allowed disabled:opacity-60"
                    disabled={uiState.loading}
                  >
                    {uiState.loading ? "Validando..." : "Ingresar"}
                  </button>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
